import { Loader2 } from 'lucide-react';
import { ReactNode } from 'react';

export type LoaderSize = 'sm' | 'md' | 'lg' | 'xl';

export interface LoaderProps {
  size?: LoaderSize;
  label?: ReactNode;
  /** Kolor spinnera. Default: accent-primary. */
  tone?: 'accent' | 'muted' | 'current';
  className?: string;
  /** Centrowanie - flex justify-center items-center wrapper. */
  center?: boolean;
}

const SIZE: Record<LoaderSize, string> = {
  sm: 'w-3.5 h-3.5',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
  xl: 'w-8 h-8',
};

const TONE: Record<NonNullable<LoaderProps['tone']>, string> = {
  accent:  'text-accent-primary',
  muted:   'text-text-muted',
  current: 'text-current',
};

const TEXT_SIZE: Record<LoaderSize, string> = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-sm',
  xl: 'text-base',
};

export function Loader({ size = 'md', label, tone = 'accent', className, center }: LoaderProps) {
  const content = (
    <span className={['inline-flex items-center gap-2', TONE[tone], className].filter(Boolean).join(' ')}>
      <Loader2 className={`${SIZE[size]} animate-spin`} />
      {label && <span className={`${TEXT_SIZE[size]} font-medium`}>{label}</span>}
    </span>
  );
  if (center) {
    return <div className="flex items-center justify-center py-6">{content}</div>;
  }
  return content;
}
